import { useState, useMemo } from 'react';
import {
    Button,
    Dialog, DialogActions, DialogContent,
    DialogTitle,
    Grid,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFAutocomplete } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { LoadingButton } from '@mui/lab';

export const AssignTicketModal = ({ open, onClose, reload, row, adminUsers }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);

    const NewDocumentSchema = Yup.object().shape({
        created_by: Yup.object().required('Admin user is required'),
    });

    const defaultValues = useMemo(() => ({ created_by: null }), []);

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const { reset, watch, handleSubmit, formState: { isSubmitting } } = methods;
    const onSubmit = handleSubmit(async (data) => {
        if (!data.created_by) {
            enqueueSnackbar({ variant: 'error', message: 'Please select an admin user.' });
            return;
        }
        setLoading(true);
        try {
            const response = await getRequest(`${endpoints.admin_dashboard.support_tickets.assign_ticket}/${row?.id}/assign-to/${data.created_by?.id}`, false, true);
            console.log("🚀 ~ get assign user:", response);
            if (response?.metadata?.success) {
                reset();
                onClose();
                enqueueSnackbar({ variant: 'success', message: response?.metadata?.message });
            } else {
                setLoading(false);
                enqueueSnackbar({ variant: 'error', message: response?.data?.metadata?.message });
            }
        } catch (err) {
        }
    });


    const hanldeclose = () => {
        reset();
        onClose();
    }


    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="sm"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Assign Ticket  &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid mt={ 2 }>
                        <RHFAutocomplete
                            name="created_by"
                            label="Admin Users"
                            options={ adminUsers }
                            getOptionLabel={ (option) => option?.name || '' }
                            isOptionEqualToValue={ (option, value) => option.id === value.id }
                            renderOption={ (props, option) => <li { ...props } key={ option.id }>{ option.name }</li> }
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ hanldeclose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting || loading }
                    >
                        Assign
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};